import { getFileName } from "@helpers/getFileName"
import { useQuery } from "@tanstack/react-query"
import { requestApi2 } from "@utils/http"
import { VesselConnectionStatus, endpoints } from "api"

export function useGetVesselsConnectionStatusQuery(args: {
	isDipaiUser: boolean
	plantIds: number[]
}) {
	const enabled = args.isDipaiUser !== false && args.plantIds.length > 0

	const res = useQuery({
		queryKey: [
			`source=${getFileName()}`,
			`queryId=GetVesselsConnectionStatus`,
			`endpoints=[${endpoints.getVesselConnectionStatus.getName()}]`,
			`plantIds=${args.plantIds}`,
			`isDipaiUser=${args.isDipaiUser}`,
		],
		queryFn: async (): Promise<VesselConnectionStatus[] | null> => {
			if (enabled === false) {
				throw new Error(
					"useGetVesselsConnectionStatusQuery requires isDipaiUser to be true"
				)
			}
			const vesselsConnectionStatus = await requestApi2(endpoints.getVesselConnectionStatus, {
				plantIds: args.plantIds,
			})
			return vesselsConnectionStatus
		},
		enabled,
		staleTime: 600000,
		refetchInterval: 600000,
	})
	return res
}
